import { Autocomplete } from "@material-ui/lab";
import {
  makeStyles,
  Tooltip,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DataService from "../../../../Service";

import { TooltipWrapper } from "../../../../Common/Utils/common_utils";
import { useState, useEffect } from "react";
const useStyles = makeStyles(() => ({
  tooltipMaxWidth: {
    maxWidth: "450px",
  },
  tooltipMinWidth: {
    maxWidth: "300px",
  },
}));
const SetupAutoComplete = (props) => {
  const classes = useStyles();
  const { searchSelectHandler, type } = props;
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    fetchDropdownsList();
  }, [inputValue]);
  const fetchDropdownsList = () => {
    DataService.getDirectData(
      `/management_information_fields/setup_search_data`,
      {
        search_type: type,
        search_attributes: inputValue,
      }
    )
      .then((res) => {
        if (res?.success) {
          setDropdownOptions(res?.data || []);
        } else {
          setDropdownOptions([]);
        }
      })
      .catch((err) => {
        setDropdownOptions([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Autocomplete
        style={{ lineHeight: "0px" }}
        loading={loading}
        renderInput={(params) => {
          return (
            <Tooltip
              placement="top-start"
              arrow
              classes={{
                tooltip:
                  inputValue.length > 250
                    ? classes.tooltipMaxWidth
                    : classes.tooltipMinWidth,
              }}
              title={
                inputValue && inputValue?.length > 24 ? (
                  <TooltipWrapper text={inputValue} />
                ) : (
                  ""
                )
              }
            >
              <TextField
                variant="outlined"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  placeholder: "Search",
                  style: {
                    fontSize: "16px",
                    fontFamily: "Open Sans",
                    marginTop: "14px",
                    marginLeft: "14px",
                    position: "absolute",
                    zIndex: 1300,
                    width: "275px",
                    height: "44px",
                    padding: 0,
                    paddingLeft: "16px",
                  },
                }}
              />
            </Tooltip>
          );
        }}
        getOptionLabel={(option) => option}
        // freeSolo
        inputValue={inputValue}
        onChange={(event) => {
          searchSelectHandler(event.target.textContent);
        }}
        onInputChange={(event, newValue) => {
          setInputValue(newValue);
        }}
        options={dropdownOptions}
      />
    </div>
  );
};
export default SetupAutoComplete;
